/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Ad } from '../models/Ad';
import type { AdPosition } from '../models/AdPosition';
import type { AdUserStateTarget } from '../models/AdUserStateTarget';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AdsService {
    /**
     * Returns banner for desired position
     * @returns Ad Success
     * @throws ApiError
     */
    public static getAdForSpace({
        placement,
        sessionId,
        apiVersion = 1,
        target,
        customerId,
        houseNumber,
    }: {
        placement: AdPosition,
        sessionId: string,
        apiVersion?: number,
        target?: Array<AdUserStateTarget>,
        customerId?: number | null,
        houseNumber?: number,
    }): CancelablePromise<Ad> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/ads/space/get',
            path: {
                'apiVersion': apiVersion,
            },
            query: {
                'placement': placement,
                'sessionId': sessionId,
                'target': target,
                'customerId': customerId,
                'houseNumber': houseNumber,
            },
            errors: {
                404: `Ad not found.`,
                500: `Internal server error.`,
            },
        });
    }
    /**
     * Call this when banner is clicked
     * @returns void
     * @throws ApiError
     */
    public static getSpaceClick({
        storyblokUuid,
        placement,
        isMobile,
        apiVersion = 1,
        customerId,
    }: {
        storyblokUuid: string,
        placement: AdPosition,
        isMobile: boolean,
        apiVersion?: number,
        customerId?: string | null,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/ads/space/click',
            path: {
                'apiVersion': apiVersion,
            },
            query: {
                'storyblokUuid': storyblokUuid,
                'placement': placement,
                'customerId': customerId,
                'isMobile': isMobile,
            },
            errors: {
                302: `User is redirected`,
            },
        });
    }
    /**
     * Logs when banner is viewed
     * @returns void
     * @throws ApiError
     */
    public static postSpaceTrackview({
        requestBody,
        apiVersion = 1,
    }: {
        requestBody: {
            storyblokUuid: string;
            placement: AdPosition;
            customerId?: number | null;
            isMobile?: boolean;
        },
        apiVersion?: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v{apiVersion}/ads/space/trackview',
            path: {
                'apiVersion': apiVersion,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
